import React, { useEffect, useState } from 'react'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { changeQuantity } from 'redux/actions';
import { isAddonRequired } from 'utils/addons';
import { getAttachment } from 'utils/attachment';
import { addToCart, getQuantity, isItemExistsInCart, subtractItem } from 'utils/cart';

function ListProduct({ product, locale }) {

  const [quantity, setQuantity] = useState(0);
  const { cartData: { cartQuantity }, fetchedData: { storeData } } = useSelector(state => state);
  const dispatch = useDispatch();

  const amount = product?.promotions?.[0]?.amount;
  const discountType = product?.promotions?.[0]?.discountType;

  const addItemToCart = (e) => {
    if (product?.stock && !isAddonRequired(product?.productAddons)) {
      e.preventDefault();
      if (product?.stock > quantity) {
        addToCart({
          ...product, 
          chosenAddons:product?.productAddons,
          price: discountType === 'AMOUNT' ? product.price - amount : discountType === 'PERCENTAGE' ? product.price - (product.price * (amount / 100)) : product.price
        });
        dispatch(changeQuantity(1))
      }
    }
  }

  const subtractItemFromCart = (e) => {
    e.preventDefault();
    subtractItem(product)
    dispatch(changeQuantity(-1))
  }

  useEffect(() => {
    setQuantity(getQuantity(product.id, product?.productAddons))
  }, [cartQuantity])


  return (
    <div className={`d-flex justify-content-between py-4 px-1 border-bottom list-view-product`} style={{ position: 'relative'}}>
      <div className={`${!product?.stock && 'soldOut'}`}>
        <div className='listProductTitle'>
          {locale === 'en' ? product?.nameEng : product?.nameAr}
        </div>
        <p className='listProductText mb-3'>
          {locale === 'en' ? product?.detailsEng : product?.detailsAr}
        </p>
        {isItemExistsInCart(product?.id, product?.productAddons) ? <div className='counterContainer d-flex justify-content py-2 pl-3 align-items-center'>
          <img onClick={subtractItemFromCart} src='/img/minusItem.svg' alt='minus' className='changeQuantity' />
          <div className='mx-3 text-black font-16'>{quantity}</div>
          <img onClick={addItemToCart} src='/img/plusItem.svg' alt='plus' className={`changeQuantity ${quantity === product?.stock && 'disabledSoldOutCounter'}`} />
        </div> :
          <Button onClick={addItemToCart} className='listProductButton card-button text-black justify-content-center px-2 d-flex align-items-center'>
            {isAddonRequired(product?.productAddons) ? 'Price on selection' : <div className='w-100 d-flex align-items-center justify-content-between'>
              <span> {storeData?.currency?.name ?? "KWD"} {product?.price}</span>
              <img src='/img/addToCart.svg' alt='addToCart'/>
            </div>}
          </Button>}
        {!product?.stock > 0 && <div className='soldOutTextList mt-2 text-black'>Sold out</div>}
        {product?.promotions?.[0]?.id ? 
          <span className='promotions'>
              { 
                discountType === 'AMOUNT' ? <>{storeData?.currency?.name ?? "KWD"} {(amount).toFixed(3)} off</> :
                discountType === 'PERCENTAGE' ? amount + '% off' : '' 
              }
          </span> : ""
        }
      </div>
      <div className={`list-product-img ${!product?.stock && 'soldOut'}`}>
        {product?.label && <div className={`productLabel ${locale !== 'en' ? "listArr" : ""}`} style={{color: product?.label?.colorLight, backgroundColor: product?.label?.colorDark}}>
            {locale === 'en' ? product?.label?.titleEng : product?.label?.titleAr}
          </div>}
        <img src={product?.images?.length ? getAttachment(product?.images[0].id) : '/img/productsFallback.svg'} alt={'product'} style={{ width: '100px', height: '100%', objectFit: 'cover', borderRadius: '10px', marginLeft: '15px'}}/>
      </div>
      {/* {product?.stock>0 && product?.promotions?.length>0 && <div className="promo_corner_product">Discount</div>} */}
    </div>
  )
}

export default ListProduct;